import { configureStore } from "@reduxjs/toolkit";
import login from "./Auth/LoginSlice"
import logout from "./Auth/LogOutSlice"
import theme from "./Theme/ThemeSlice"
import formulaTypes from "./FormulaTypes/FormulaTypesSlice"
import color from "./Colors/ColorsSlice"
import dentist from "./Dentist/DentistSlice"
import order from "./Orders/OrderSlice"
import settings from "./LabData/LabDataSlice"
import expensesType from "./Expenses/ExpensesTypeSlice"
import expenses from "./Expenses/ExpensesSlice"
import assetsReducer from "./Assets/AssetSlice";
import statsReducer from "./Stats/StatsSlice";
import language from "./Language/LanguageSlice";
import users from "./Users/UserSlice";
import transactions from "./Transactions/TransactionsSlice";
import branchs from "./Branchs/BranchsSlice";
import deliveryCenters from "./DeliveryCenters/DeliveryCentersSlice";
import deliveryTypes from "./DeliveryTypes/DeliveryTypesSlice";
import clients from "./Clients/ClientsSlice";
import profile from "./Profile/ProfileSlice";
import vacations from "./Vacations/VacationsSlice";
import priceVisibility from "./PriceVisibility/PriceVisibilitySlice";

export default configureStore({
    reducer: {
        login,
        logout,
        theme,
        formulaTypes,
        color,
        dentist,
        order,
        settings,
        expensesType,
        expenses,
        stats: statsReducer,
        assets: assetsReducer,
        language,
        users,
        transactions,
        branchs,
        deliveryCenters,
        deliveryTypes,
        clients,
        profile,
        vacations,
        priceVisibility,
    }
})